(function($) {
    $(".js-datepicker").each(function(index, element){
        console.log(element);
        var $element = $(element);
        var options = $element.data();
        var defaults = {
            singleDatePicker: true,
            container: "html",
            "locale": {
                "format": "DD.MM.YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "W",
                "daysOfWeek": [
                    "P",
                    "E",
                    "T",
                    "K",
                    "N",
                    "R",
                    "L"
                ],
                "monthNames": [
                    "Jaanuar",
                    "Veebruar",
                    "Märts",
                    "Aprill",
                    "Mai",
                    "Juuni",
                    "Juuli",
                    "August",
                    "September",
                    "Oktoober",
                    "November",
                    "Detsember"
                ],
                "firstDay": 1
            }

        };
        if(!$.isEmptyObject(options)){
            $element.on("focus", function(element){
                $element.daterangepicker(options);
            });
        }else{
            $element.on("focus", function(element){
                $element.daterangepicker(defaults);
            });
        }

    });


})(jQuery);
